





















































































































































































































import CreateDialog from '@/components/CreateDialog.vue'
import { required, email } from '@/utils/validators'
import PhoneTextField from '@/components/PhoneTextField.vue'
import Autocomplete from '@/components/Autocomplete.vue'
import { getSubregions } from '@/api/Address/address'
import PasswordField from '@/components/PasswordField.vue'
import { VueForm, CrudUser, Iterable, Services } from '@/utils/interfaces'
import { createUser, getUsers } from '@/api/Users/users.api'
import { TranslateResult } from 'vue-i18n'
import { editMixin } from '@/utils/mixins/editMixin'
import { Roles } from '@/utils/roles.constant'
import mixins from 'vue-typed-mixins'
import { crudMixin } from '@/utils/mixins/crudMixin'
import { getAgencies } from '@/api/Agency/agency.api'
import { getServices } from '@/api/Services/services.api'
import Avatar from '@/components/Avatar.vue'
import ChangePasswordVue from './ChangePassword.vue'
import LanguageSelector from '@/components/Dashboard/LanguageSelector.vue'

export default mixins(editMixin, crudMixin).extend({
  components: {
    appCreateDialog: CreateDialog,
    PhoneTextField: PhoneTextField,
    appAutocomplete: Autocomplete,
    appPasswordField: PasswordField,
    appAvatar: Avatar,
    appPasswordDialog: ChangePasswordVue,
    appLanguageSelector: LanguageSelector,
  },
  data() {
    return {
      passwordDialog: false,
      loading: {
        general: false,
        services: false,
      },
      roles: Roles.filter(role => role.value !== 'WHOLESALER').map(item => {
        item.text = this.$t(item.text as string)
        return item
      }),
      rules: {
        required: (v: string) => required(v) || this.$t('field-required'),
        email: (v: string) => email(v) || this.$t('must-be-valid-email'),
        repeat: (v: string) =>
          this.$data.crud.password === v || this.$t('passwords-must-match'),
      },
      crud: {} as CrudUser,
      defaultCrud: {
        first_name: '',
        last_name: '',
        email: '',
        username: '',
        password: '',
        re_password: '',
        phone: '+1',
        lang: 'es',
        address: {
          address_1: '',
        },
        image: null as null | File,
        services: [],
        agency: undefined,
        can_create: false,
        can_create_agents: false,
        role: 'AGENT',
        email_notify: false,
      } as CrudUser,
      getSubregions: getSubregions,
      getAgencies: getAgencies,
      getUsers: getUsers,
      services: [] as Services[],
    }
  },
  computed: {
    src(): string {
      try {
        const image = URL.createObjectURL(this.crud.image)
        return image
      } catch (error) {
        return ''
      }
    },
    title(): TranslateResult {
      if (this.editedItem) return this.$t('edit-user')
      return this.$t('create-user')
    },
    acceptText(): TranslateResult {
      if (this.editedItem) return this.$t('edit')
      return this.$t('create')
    },
  },
  methods: {
    async onSuccess(): Promise<void> {
      if (!(this.$refs.form as VueForm).validate()) return
      this.loading.general = true
      try {
        if (
          (this.crud as CrudUser & { uuid: string }).uuid ===
          this.$store.getters.profile.uuid
        ) {
          delete this.crud.services
        } else {
          this.crud.services = this.crud.services.filter(service =>
            this.services.find(ser => service === ser.name),
          )
        }

        const response = await createUser(this.crud as Iterable)
        this.$emit('new-user', response.data)
        this.$emit('input', false)
        setTimeout(() => {
          this.resetCrud()
          ;(this.$refs.form as VueForm).resetValidation()
        }, 300)
      } finally {
        this.loading.general = false
      }
    },
  },
  async mounted() {
    try {
      this.loading.services = true
      const response = await getServices()
      this.services = response.data.results.filter(service => service.active)
      if (!this.$store.getters.profile.is_superuser) {
        this.services = this.services.filter(service =>
          this.$store.getters.profile.services.includes(service.name),
        )
      }
    } finally {
      this.loading.services = false
    }
  },
})
